import React from 'react';
const AppContext = React.createContext({
    message: {},
    notification: {},
    modal: {},
});
export default AppContext;
